import { DeviceDTO } from '@eppendorf/vnls-device-service-utils';
import { QueryClient } from '@tanstack/react-query';
import { ReactElement } from 'react';

import { prepopulateCache } from '$shared/utils/react-query.utils';

import { DeviceDetailWrapper } from '$features/devices/device-detail-wrapper';
import { createDeviceQuery } from '$features/devices/devices.api';

export async function deviceDetailLoader(
  queryClient: QueryClient,
  deviceSearch: Pick<DeviceDTO, 'manufacturer' | 'serialNumber'>,
): Promise<null> {
  return prepopulateCache<DeviceDTO>(queryClient, createDeviceQuery(deviceSearch));
}

export function DeviceDetailPage(): ReactElement {
  return <DeviceDetailWrapper />;
}
